import instance from './axiosInstance';
import type { SessionData, UpdateSessionPayload } from 'pages/sessionTags/types';

export const getSessionTag = async <T = SessionData>(ssdType: string): Promise<T> => {
  const res = await instance.get<T>('/session_tag?ssd_type=' + ssdType);
  return res.data;
};

export const updateSessionTag = async (sessionData: UpdateSessionPayload) => {
  const res = await instance.post('/session_tag', sessionData);
  return res.data;
};
